// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3Xf--","right":"styles_right__3_Q0y"};